import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';

/* State */
import { AuthState } from '@core/store/auth/auth.state';

@Injectable({
	providedIn: 'root',
})
export class LoginGuard  {
	constructor(private router: Router, private store: Store) {}

	canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
		if (route.routeConfig.path === 'login-with-recovery-code') {
			return this.store.selectSnapshot(AuthState.loginInProgress) ? true : this.router.parseUrl('login');
		}

		return this.store.selectSnapshot(AuthState.isAuthenticated) ? false : true;
	}
}
